import { FC } from 'react';

import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import ReactCountryFlag from 'react-country-flag';

import { useLanguage } from '@/hooks/useLanguage';
import { ACTIVE_LANGUAGES } from '@/i18n/languages';

const RLanguageSwitcher: FC = () => {
  const { currentLanguage, changeLanguage } = useLanguage();

  // Aktif dillerden dropdown menüsü oluştur
  const items: MenuProps['items'] = ACTIVE_LANGUAGES.map((lang) => ({
    key: lang.code,
    label: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <ReactCountryFlag
          countryCode={lang.countryCode}
          svg
          style={{ width: '20px', height: '15px' }}
        />
        <span>{lang.nativeName}</span>
      </div>
    ),
    onClick: () => changeLanguage(lang.code),
  }));

  // Mevcut dilin konfigürasyonunu bul
  const currentLangConfig = ACTIVE_LANGUAGES.find(
    (lang) => lang.code === currentLanguage
  );

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Button
        type="text"
        style={{
          color: 'inherit',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        {currentLangConfig && (
          <ReactCountryFlag
            countryCode={currentLangConfig.countryCode}
            svg
            style={{ width: '16px', height: '12px' }}
          />
        )}
        <span>{currentLanguage.toUpperCase()}</span>
      </Button>
    </Dropdown>
  );
};

export default RLanguageSwitcher;
